
export default (store) => ({
    path : 'login',
    /*  Async getComponent is only invoked when route matches   */
    getComponent (nextState, cb) {
        /*  Webpack - use 'require.ensure' to create a split point
         and embed an async module loader (jsonp) when bundling   */
        require.ensure([], (require) => {
          const Login = require('./containers/loginContainer').default
          cb(null, Login)
        }, 'login')
    }
})



// WEBPACK FOOTER //
// ./src/routes/Login/index.js